export const matchingFields = [
  [
    "components.distributionSystem.dist_header_cl_cwb_curb",
    "generalTowerDescription.dist_header_cl_cwb_curb",
  ],
  [
    "components.distributionSystem.dist_cell_arrangement_cf",
    "tower.distribution_system",
    "scopeOfWork.fandeckSow.sow_fandeck_back_to_back_distr",
    "scopeOfWork.fillSow.sow_fill_back_to_back_distr",
    "scopeOfWork.firewallSow.sow_firewall_back_to_back_distr",
    "scopeOfWork.distributionSystemSow.sow_distribution_back_to_back_distr",
    "scopeOfWork.driftEliminatorsCFSow.sow_de_back_to_back_distr_cf",
    "scopeOfWork.partitionwallSow.sow_partitionwall_back_to_back_distr_cf",
    "scopeOfWork.windwallSow.sow_windwall_back_to_back_distr",
  ],

  [
    "components.fakefordatamatch.model",
    "generalTowerDescription.model",
    "scopeOfWork.driftEliminatorsCFSow.sow_de_cf_model_number",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_model_number",
    "scopeOfWork.distributionSystemSow.sow_distribution_model_number",
    "scopeOfWork.laddersSow.sow_ladder_model_number",
    "scopeOfWork.partitionwallSow.sow_partitionwall_model_number",
    "scopeOfWork.stairwaySow.sow_stairway_model_number",
    "scopeOfWork.windwallSow.sow_windwall_model_number",
    "scopeOfWork.firewallSow.sow_firewall_model_number",
    "scopeOfWork.fillSow.sow_fill_model_number",
    "scopeOfWork.structureSow.sow_structure_model_number",
  ],
  [
    "components.fakefordatamatch.tower_manufacturer",
    "generalTowerDescription.manufacturer",
    "scopeOfWork.driftEliminatorsCFSow.sow_de_cf_tower_manufacturer",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_tower_manufacturer",
    "scopeOfWork.distributionSystemSow.sow_distribution_tower_manufacturer",
    "scopeOfWork.laddersSow.sow_ladder_tower_manufacturer",
    "scopeOfWork.partitionwallSow.sow_partitionwall_tower_manufacturer",
    "scopeOfWork.stairwaySow.sow_stairway_tower_manufacturer",
    "scopeOfWork.windwallSow.sow_windwall_tower_manufacturer",
    "scopeOfWork.firewallSow.sow_firewall_tower_manufacturer",
    "scopeOfWork.fillSow.sow_fill_tower_manufacturer",
    "scopeOfWork.structureSow.sow_structure_tower_manufacturer",
  ],
  [
    //"generalTowerDescription.towerType",
    "generalTowerDescription.towerSubtype",
    "scopeOfWork.distributionSystemSow.sow_distribution_tower_subtype",
    "components.distributionSystem.dist_cell_subtype_cf",
    "scopeOfWork.fillSow.sow_fill_tower_subtype",
    "scopeOfWork.firewallSow.sow_firewall_tower_subtype_cf",
    "scopeOfWork.partitionwallSow.sow_partitionwall_tower_subtype",
    "scopeOfWork.structureSow.sow_structure_tower_subtype_cf",
    "scopeOfWork.windwallSow.sow_windwall_tower_subtype",
    //"tower.towerType",
  ],
  [
    "scopeOfWork.distributionSystemSow.sow_distribution_tower_subtype_other",
    "scopeOfWork.fillSow.sow_fill_tower_type_other",
    "scopeOfWork.firewallSow.sow_firewall_tower_subtype_other",
    "scopeOfWork.partitionwallSow.sow_partitionwall_tower_type_other",
    "scopeOfWork.structureSow.sow_structure_tower_type_other",
    "scopeOfWork.windwallSow.sow_windwall_tower_subtype_other",
  ],
  [
    "components.fakefordatamatch.towerSubtype",
    "generalTowerDescription.towerSubtype",
    "scopeOfWork.distributionSystemSow.sow_distribution_tower_subtype",
    "components.distributionSystem.dist_cell_subtype_cf",
    "scopeOfWork.driftEliminatorsCFSow.sow_de_cf_tower_subtype",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_tower_subtype",
    "scopeOfWork.fandeckSow.sow_fandeck_tower_subtype",
    "tower.subtype",
    "scopeOfWork.fandeckSow.sow_fandeck_tower_subtype_counterflow",
    "scopeOfWork.fillSow.sow_fill_tower_subtype",
    "scopeOfWork.firewallSow.sow_firewall_tower_subtype_cf",
    "scopeOfWork.structureSow.sow_structure_tower_subtype_cf",
    "scopeOfWork.partitionwallSow.sow_partitionwall_tower_subtype",
    "scopeOfWork.windwallSow.sow_windwall_tower_subtype",
  ],
  [
    "components.fakefordatamatch.cellLength",
    "generalTowerDescription.cellLength",
    "scopeOfWork.driftEliminatorsCFSow.sow_de_cf_cell_length",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_cell_length",
    "scopeOfWork.fandeckSow.sow_fandeck_cell_length",
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_cell_length",
    "scopeOfWork.mngSupportSow.sow_mng_cell_length",
    "scopeOfWork.distributionSystemSow.sow_distribution_cell_length",
    "scopeOfWork.fillSow.sow_fill_cell_length",
    "scopeOfWork.windwallSow.sow_windwall_cell_length",
    "scopeOfWork.partitionwallSow.sow_partitionwall_cell_length",
    "scopeOfWork.firewallSow.sow_firewall_cell_length",
    "scopeOfWork.structureSow.sow_structure_cell_length",
  ],
  [
    "components.fakefordatamatch.cellWidth",
    "components.generalInfo.cellWidth",
    "generalTowerDescription.cellWidth",
    "components.fandeck.fandeck_cell_width",
    "scopeOfWork.driftEliminatorsCFSow.sow_de_cf_cell_width",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_cell_width",
    "scopeOfWork.fandeckSow.sow_fandeck_cell_width",
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_cell_width",
    "scopeOfWork.mngSupportSow.sow_mng_cell_width",
    "scopeOfWork.distributionSystemSow.sow_distribution_cell_width",
    "scopeOfWork.fillSow.sow_fill_cell_width",
    "scopeOfWork.firewallSow.sow_firewall_cell_width",
    "scopeOfWork.windwallSow.sow_windwall_cell_width",
    "scopeOfWork.partitionwallSow.sow_partitionwall_cell_width",
    "scopeOfWork.structureSow.sow_structure_cell_width",
  ],
  [
    "components.fakefordatamatch.cellHeight",
    "generalTowerDescription.cellHeight",
    "scopeOfWork.fanstackSow.sow_fanstack_cell_height",
    "scopeOfWork.partitionwallSow.sow_partitionwall_cell_height",
    "scopeOfWork.firewallSow.sow_firewall_cell_height",
    "scopeOfWork.structureSow.sow_structure_cell_height",
  ],
  [
    "generalTowerDescription.cwb_grade_to_curb_height",
    "components.coldWaterBasin.cwb_grade_to_curb_height",
    "scopeOfWork.laddersSow.sow_ladder_grade_to_curb",
  ],
  [
    "components.fandeck.fandeck_joist_wood_type",
    "scopeOfWork.fandeckSow.sow_fandeck_joist_wood_type",
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_fandeck_joist_wood_type",
    "scopeOfWork.mngSupportSow.sow_mng_joist_wood_type",
    "scopeOfWork.fanstackSow.sow_fanstack_joist_wood_type",
    "scopeOfWork.partitionwallSow.sow_partitionwall_fandeck_joist_wood_type",
    "scopeOfWork.firewallSow.sow_firewall_fandeck_joist_wood_type",
  ],
  [
    "components.fandeck.fandeck_joist_wood_other",
    "scopeOfWork.fandeckSow.sow_fandeck_joist_wood_type_other",
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_fandeck_joist_wood_type_other",
    "scopeOfWork.mngSupportSow.sow_mng_joist_wood_type_other",
    "scopeOfWork.fanstackSow.sow_fanstack_joist_wood_other",
    "scopeOfWork.partitionwallSow.sow_partitionwall_fandeck_joist_wood_other",
    "scopeOfWork.firewallSow.sow_firewall_fandeck_joist_wood_other",
  ],
  [
    "components.fandeck.fandeck_joist_wood_hardware",
    "scopeOfWork.fandeckSow.sow_fandeck_wood_hardware",
    "scopeOfWork.fandeckSow.sow_fandeck_joist_wood_hardware",
  ],
  [
    "components.fandeck.fandeck_joist_wood_hardware_other",
    "scopeOfWork.fandeckSow.sow_fandeck_wood_hardware_other",
    "scopeOfWork.fandeckSow.sow_fandeck_joist_wood_hardware_other",
  ],
  [
    "components.fandeck.fandeck_joist_frp_hardware",
    "scopeOfWork.fandeckSow.sow_fandeck_frp_hardware",
    "scopeOfWork.fandeckSow.sow_fandeck_joist_frp_hardware",
  ],
  [
    "components.fandeck.fandeck_joist_frp_hardware_other",
    "scopeOfWork.fandeckSow.sow_fandeck_frp_hardware_other",
    "scopeOfWork.fandeckSow.sow_fandeck_joist_frp_hardware_other",
  ],
  [
    "components.fakefordatamatch.baySizeLength",
    "generalTowerDescription.baySizeLength",
    "scopeOfWork.driftEliminatorsCFSow.sow_de_cf_bay_length",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_bay_length",
    "scopeOfWork.fandeckSow.sow_fandeck_bay_length",
    "scopeOfWork.distributionSystemSow.sow_distribution_bay_size_length",
    "scopeOfWork.fillSow.sow_fill_bay_size_length",
    "scopeOfWork.structureSow.sow_structure_bay_size_length",
    "scopeOfWork.partitionwallSow.sow_partitionwall_bay_size_length",
    "scopeOfWork.mngSupportSow.sow_mng_bay_size",
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_bay_size_length",
    "scopeOfWork.windwallSow.sow_windwall_bay_size_length",
    "scopeOfWork.laddersSow.sow_ladder_longl_bay_length",
    "scopeOfWork.firewallSow.sow_firewall_bay_size_length",
    "scopeOfWork.fanstackSow.sow_fanstack_bay_length",
    "scopeOfWork.stairwaySow.sow_stairway_longl_bay_length",
  ],
  [
    "components.fakefordatamatch.baySizeLengthOther",
    "generalTowerDescription.baySizeLength",
    "scopeOfWork.driftEliminatorsCFSow.sow_de_cf_bay_length_other",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_bay_length_other",
    "scopeOfWork.fandeckSow.sow_fandeck_bay_length_other",
    "scopeOfWork.distributionSystemSow.sow_distribution_bay_size_length_other",
    "scopeOfWork.fillSow.sow_fill_bay_size_length_other",
    "scopeOfWork.structureSow.sow_structure_bay_size_length_other",
    "scopeOfWork.partitionwallSow.sow_partitionwall_bay_size_length_other",
    "scopeOfWork.mngSupportSow.sow_mng_bay_size_other",
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_bay_size_length_other",
    "scopeOfWork.windwallSow.sow_windwall_bay_size_length_other",
    "scopeOfWork.laddersSow.sow_ladder_longl_bay_length_other",
    "scopeOfWork.firewallSow.sow_firewall_bay_size_length_other",
    "scopeOfWork.fanstackSow.sow_fanstack_bay_length_other",
    "scopeOfWork.stairwaySow.sow_stairway_longl_bay_length_other",
  ],
  [
    "components.fakefordatamatch.baySizeWidth",
    "generalTowerDescription.baySizeWidth",
    "scopeOfWork.fandeckSow.sow_fandeck_bay_width",
    "scopeOfWork.distributionSystemSow.sow_distribution_bay_size_width",
    "scopeOfWork.fillSow.sow_fill_bay_size_width",
    "scopeOfWork.firewallSow.sow_firewall_bay_size_width",
    "scopeOfWork.structureSow.sow_structure_bay_size_width",
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_bay_size_width",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_bay_width",
    "scopeOfWork.driftEliminatorsCFSow.sow_de_cf_bay_width",
    "scopeOfWork.windwallSow.sow_windwall_bay_size_width",
    "scopeOfWork.laddersSow.sow_ladder_trans_bay_width",
    "scopeOfWork.partitionwallSow.sow_partitionwall_bay_size_width",
    "scopeOfWork.stairwaySow.sow_stairway_trans_bay_width",
  ],
  [
    "components.fakefordatamatch.baySizeWidthOther",
    "generalTowerDescription.baySizeWidthOther",
    "scopeOfWork.fandeckSow.sow_fandeck_bay_width_other",
    "scopeOfWork.distributionSystemSow.sow_distribution_bay_size_width_other",
    "scopeOfWork.fillSow.sow_fill_bay_size_width_other",
    "scopeOfWork.firewallSow.sow_firewall_bay_size_width_other",
    "scopeOfWork.structureSow.sow_structure_bay_size_width_other",
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_bay_size_width_other",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_bay_width_other",
    "scopeOfWork.driftEliminatorsCFSow.sow_de_cf_bay_width_other",
    "scopeOfWork.windwallSow.sow_windwall_bay_size_width_other",
    "scopeOfWork.laddersSow.sow_ladder_trans_bay_width_other",
    "scopeOfWork.partitionwallSow.sow_partitionwall_bay_size_width_other",
    "scopeOfWork.stairwaySow.sow_stairway_trans_bay_width_other",
  ],
  [
    "components.fakefordatamatch.baySizeHeight",
    "generalTowerDescription.baySizeHeight",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_bay_height",
    "scopeOfWork.structureSow.sow_structure_bay_size_height",
  ],
  [
    "components.fakefordatamatch.baySizeHeightOther",
    "generalTowerDescription.baySizeHeightOther",
    "scopeOfWork.driftEliminatorsCFSow.sow_de_cf_bay_height_other",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_bay_height_other",
    "scopeOfWork.structureSow.sow_structure_bay_size_height_other",
  ],
  [
    "generalTowerDescription.fan_diameter",
    "components.mechanical.fan_diameter",
    "components.fanstack.fanstack_diameter",
    "scopeOfWork.driveShaftSow.sow_driveshaft_fan_diameter",
    "scopeOfWork.fanSow.sow_fan_diameter",
    "scopeOfWork.fandeckSow.sow_fandeck_fan_diameter",
    "scopeOfWork.gearSow.sow_gear_fan_diameter",
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_fan_diameter",
    "scopeOfWork.mngSupportSow.sow_mng_fan_diameter",
    "scopeOfWork.fanstackSow.sow_fanstack_diameter",
  ],
  [
    "generalTowerDescription.fan_diameter",
    "components.mechanical.fan_diameter_other",
    "components.fanstack.fanstack_diameter_other",
    "scopeOfWork.driveShaftSow.sow_driveshaft_fan_diameter_other",
    "scopeOfWork.fanSow.sow_fan_diameter_other",
    "scopeOfWork.fandeckSow.sow_fandeck_fan_diameter_other",
    "scopeOfWork.gearSow.sow_gear_fan_diameter_other",
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_fan_diameter_other",
    "scopeOfWork.mngSupportSow.sow_mng_fan_diameter_other",
    "scopeOfWork.fanstackSow.sow_fanstack_diameter_other",
  ],
  [
    "components.fakefordatamatch.numberOfCells",
    "generalTowerDescription.numberOfCells",
    "scopeOfWork.distributionSystemSow.sow_distribution_number_of_cells",
    "scopeOfWork.driftEliminatorsCFSow.sow_de_cf_total_cells",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_total_cells",
    "scopeOfWork.fillSow.sow_fill_total_cells",
    "scopeOfWork.firewallSow.sow_firewall_number_of_cells",
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_number_of_cells",
    "scopeOfWork.partitionwallSow.sow_partitionwall_number_of_cells",
    "scopeOfWork.structureSow.sow_structure_number_of_cells",
    "scopeOfWork.windwallSow.sow_windwall_number_of_cells",
  ],
  [
    "generalTowerDescription.louver_exists",
    "components.louvers.louver_exists_cf",
    "components.louvers.louver_exists_xf",
    "components.louvers.louver_exists",
  ],
  [
    "generalTowerDescription.louver_row_count",
    "components.louvers.louver_row_count_cf",
    "components.louvers.louver_row_count_xf",
    "components.louvers.louver_row_count",
  ],
  [
    "generalTowerDescription.louver_blade_width",
    "components.louvers.louver_blade_width_cf",
    "components.louvers.louver_blade_width_xf",
    "components.louvers.louver_blade_width",
  ],
  [
    "generalTowerDescription.louver_blade_width",
    "components.louvers.louver_blade_width_other_cf",
    "components.louvers.louver_blade_width_other_xf",
  ],
  [
    "generalTowerDescription.louver_material",
    "components.louvers.louver_material_cf",
    "components.louvers.louver_material_xf",
    "components.louvers.louver_material",
  ],
  [
    "generalTowerDescription.louver_material",
    "components.louvers.louver_material_other_cf",
    "components.louvers.louver_material_other_xf",
  ],
  [
    "generalTowerDescription.stairway_count",
    "components.stairway.stairway_count",
  ],
  [
    "generalTowerDescription.stairway_count",
    "components.stairway.stairway_count_other",
  ],
  [
    "scopeOfWork.stairwaySow.sow_stairway_height",
    "components.stairway.stairway_height",
  ],
  [
    "scopeOfWork.stairwaySow.sow_stairway_existing_type",
    "components.stairway.stairway_type",
  ],
  [
    "scopeOfWork.stairwaySow.sow_stairway_existing_pad_size",
    "components.stairway.stairway_pad_size",
  ],
  [
    "scopeOfWork.stairwaySow.sow_stairway_existing_enclosed",
    "components.stairway.stairway_enclosed",
  ],
  [
    "components.stairway.stairway_post_design",
    "scopeOfWork.stairwaySow.sow_stairway_existing_post_type",
  ],
  [
    "scopeOfWork.driftEliminatorsCFSow.sow_de_cf_casing_material",
    "scopeOfWork.laddersSow.sow_ladder_existing_casing",
    "components.casing.casing_material_cf",
    "components.casing.casing_material_xf",
    "scopeOfWork.partitionwallSow.sow_partitionwall_casing_material",
    "scopeOfWork.stairwaySow.sow_stairway_existing_casing",
    "scopeOfWork.fillSow.sow_fill_casing_material",
    "scopeOfWork.distributionSystemSow.sow_distribution_casing_material",
    "scopeOfWork.firewallSow.sow_firewall_casing_material",
    "scopeOfWork.structureSow.sow_structure_casing_material",
  ],
  [
    "components.casing.casing_material_other_cf",
    "components.casing.casing_material_other_xf",
  ],
  [
    "generalTowerDescription.structure_material",
    "components.structure.structure_material",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_trans_ties_material",
    "scopeOfWork.firewallSow.sow_firewall_posts_braces",
  ],
  [
    "components.fakefordatamatch.airInletHeight",
    "generalTowerDescription.airInletHeight",
    "scopeOfWork.windwallSow.sow_windwall_air_inlet_height",
    "scopeOfWork.partitionwallSow.sow_partitionwall_air_inlet_height",
    "scopeOfWork.structureSow.sow_structure_air_inlet_height",
    "scopeOfWork.laddersSow.sow_ladder_air_inlet_height",
    "scopeOfWork.firewallSow.sow_firewall_air_inlet_height",
  ],
  [
    "generalTowerDescription.casing_air_inlets",
    "components.casing.casing_air_inlets_cf",
    "components.casing.casing_air_inlets_xf",
    "scopeOfWork.windwallSow.sow_windwall_end_walls",
    "scopeOfWork.structureSow.sow_structure_air_inlet_end_wall",
  ],
  [
    "generalTowerDescription.fill_type",
    "components.fill.fill_type_cf",
    "components.fill.fill_type_xf",
    "components.fill.fill_type",
    "scopeOfWork.firewallSow.sow_firewall_existing_fill_type",
    "scopeOfWork.fillSow.sow_fill_existing_type",
    "scopeOfWork.partitionwallSow.sow_partitionwall_existing_fill_type",
  ],
  [
    "generalTowerDescription.fill_type",
    "scopeOfWork.partitionwallSow.sow_partitionwall_fill_type_other",
    "components.fill.fill_type_other_cf",
    "components.fill.fill_type_other_xf",
    "components.fill.fill_type_other",
    "scopeOfWork.fillSow.sow_fill_type_other",
  ],
  [
    "generalTowerDescription.fanstack_height",
    "components.mechanical.fanstack_height",
    "components.fanstack.fanstack_height",
    "scopeOfWork.mngSupportSow.sow_mng_fanstack_height",
    "scopeOfWork.fanSow.sow_fan_spider_cables_height",
    "scopeOfWork.fandeckSow.sow_fandeck_fanstack_height",
    "scopeOfWork.fanstackSow.sow_fanstack_height_existing",
    "scopeOfWork.gearSow.sow_gear_fanstack_height",
  ],
  [
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_fan_blade_tracking",
    "scopeOfWork.fanstackSow.sow_fanstack_fan_blade_tracking_elevation",
  ],
  [
    "generalTowerDescription.fanstack_height",
    "components.fanstack.fanstack_height_other",
    "scopeOfWork.fanSow.sow_fan_spider_cables_height_other",
    "scopeOfWork.fandeckSow.sow_fandeck_fanstack_height_other",
    "scopeOfWork.fanstackSow.sow_fanstack_height_existing_other",
    "scopeOfWork.gearSow.sow_gear_fanstack_height_other",
    "scopeOfWork.mngSupportSow.sow_mng_fanstack_height_other",
  ],
  ["generalTowerDescription.ladder_count", "components.ladders.ladder_count"],
  [
    "generalTowerDescription.ladder_count",
    "components.ladders.ladder_count_other",
  ],
  [
    "components.ladders.ladder_height",
    "scopeOfWork.laddersSow.sow_ladder_height",
  ],
  [
    "components.ladders.ladder_material",
    "scopeOfWork.laddersSow.sow_ladder_existing_material",
  ],
  [
    "components.ladders.ladder_landing_count",
    "scopeOfWork.laddersSow.sow_ladder_existing_landings",
  ],
  [
    "components.ladders.ladder_landing_material",
    "scopeOfWork.laddersSow.sow_ladder_existing_landing_material",
  ],
  [
    "generalTowerDescription.motor_hp",
    "scopeOfWork.mngSupportSow.sow_mng_motor_hp",
    "components.mechanical.motor_hp",
    "scopeOfWork.motorSow.sow_motor_hp",
    "scopeOfWork.driveShaftSow.sow_driveshaft_motor_hp",
    "scopeOfWork.gearSow.sow_gear_motor_hp",
  ],
  [
    "components.mechanical.motor_rpm",
    "scopeOfWork.gearSow.sow_gear_motor_rpm",
    "scopeOfWork.fanSow.sow_driveshaft_motor_rpm",
    "scopeOfWork.driveShaftSow.sow_driveshaft_motor_rpm",
    "scopeOfWork.motorSow.sow_motor_rpm",
  ],
  [
    "components.mechanical.motor_rpm_other",
    "scopeOfWork.gearSow.sow_gear_motor_rpm_other",
    "scopeOfWork.fanSow.sow_driveshaft_motor_rpm_other",
    "scopeOfWork.driveShaftSow.sow_driveshaft_motor_rpm_other",
    "scopeOfWork.motorSow.sow_motor_rpm_other",
  ],
  [
    "components.mechanical.motor_rpm_value",
    "scopeOfWork.driveShaftSow.sow_driveshaft_motor_rpm_value",
  ],
  [
    "components.mechanical.gear_manufacturer",
    "scopeOfWork.fanSow.sow_fan_gear_manufacturer",
    "scopeOfWork.mngSupportSow.sow_mng_gear_manufacturer",
    "scopeOfWork.gearSow.sow_gear_existing_manufacturer",
    "scopeOfWork.driveShaftSow.sow_driveshaft_gear_manufacturer",
  ],
  [
    "components.mechanical.gear_model",
    "scopeOfWork.fanSow.sow_fan_gear_model",
    "scopeOfWork.gearSow.sow_gear_existing_model",
    "scopeOfWork.mngSupportSow.sow_mng_gear_model",
    "scopeOfWork.driveShaftSow.sow_driveshaft_gear_model",
  ],
  [
    "components.mechanical.gear_model_known",
    "scopeOfWork.fanSow.sow_fan_gear_model_known",
    "scopeOfWork.gearSow.sow_gear_model_known",
    "scopeOfWork.driveShaftSow.sow_driveshaft_gear_model_known",
  ],
  [
    "components.mechanical.gear_ratio",
    "scopeOfWork.driveShaftSow.sow_driveshaft_gear_ratio",
  ],
  [
    "components.fandeck.fandeck_material",
    "scopeOfWork.fandeckSow.sow_fandeck_material",
    "scopeOfWork.fanstackSow.sow_fanstack_fandeck_material",
  ],
  [
    "components.fandeck.fandeck_material_frp",
    "scopeOfWork.fanstackSow.sow_fanstack_fandeck_material_frp",
    "scopeOfWork.fandeckSow.sow_fandeck_material_frp",
  ],
  [
    "components.fandeck.fandeck_material_frp_other",
    "scopeOfWork.fanstackSow.sow_fanstack_fandeck_material_frp_other",
    "scopeOfWork.fandeckSow.sow_fandeck_material_frp_other",
  ],
  [
    "components.fandeck.fandeck_material_wood",
    "scopeOfWork.fanstackSow.sow_fanstack_fandeck_material_wood",
    "scopeOfWork.fandeckSow.sow_fandeck_material_wood",
  ],
  [
    "components.fandeck.fandeck_material_wood_other",
    "scopeOfWork.fanstackSow.sow_fanstack_fandeck_material_wood_other",
    "scopeOfWork.fandeckSow.sow_fandeck_material_wood_other",
  ],

  [
    "components.driftEliminators.de_height_xf",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_total_height",
  ],
  [
    "components.driftEliminators.de_type_xf",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_existing_type",
  ],
  [
    "components.driftEliminators.de_support_material_xf",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_support_material",
  ],
  [
    "components.driftEliminators.de_top_shelf_width_xf",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_top_shelf_width",
  ],
  [
    "components.driftEliminators.de_top_shelf_material_xf",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_existing_top_shelf_material",
  ],
  [
    "components.driftEliminators.de_intermediate_shelves_xf",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_intermediate_shelves",
  ],
  [
    "components.driftEliminators.de_intermediate_shelf_material_xf",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_existing_interm_shelf_material",
  ],
  [
    "components.driftEliminators.structure_material",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_trans_ties_material",
  ],
  [
    "components.partitionwall.partitionwall_material",
    "scopeOfWork.partitionwallSow.sow_partitionwall_material_existing",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_partition_material",
    "scopeOfWork.structureSow.sow_structure_partition_material",
  ],
  [
    "components.partitionwall.partitionwall_frp_type",
    "scopeOfWork.partitionwallSow.sow_partitionwall_existing_frp_type",
    "scopeOfWork.driftEliminatorsXFSow.partitionwall_frp_type",
  ],
  [
    "components.partitionwall.partitionwall_frp_other",
    "scopeOfWork.partitionwallSow.sow_partitionwall_existing_frp_other",
    "scopeOfWork.driftEliminatorsXFSow.partitionwall_frp_other",
  ],
  [
    "components.partitionwall.partitionwall_wood_type",
    "scopeOfWork.partitionwallSow.sow_partitionwall_existing_wood_type",
    "scopeOfWork.driftEliminatorsXFSow.partitionwall_wood_type",
  ],
  [
    "components.partitionwall.partitionwall_wood_other",
    "scopeOfWork.parititionwallSow.sow_partitionwall_existing_wood_other",
    "scopeOfWork.driftEliminatorsXFSow.partitionwall_wood_other",
  ],
  [
    "components.partitionwall.partitionwall_material_other",
    "scopeOfWork.partitionwallSow.sow_partitionwall_material_existing_other",
    "scopeOfWork.driftEliminatorsXFSow.partitionwall_material_other",
    "scopeOfWork.structureSow.sow_structure_partition_other",
  ],
  [
    "components.partitionwall.sow_structure_partition_both_sides",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_partition_both_sides",
  ],
  [
    "components.partitionwall.partitionwall_panels_both_sides",
    "scopeOfWork.partitionwallSow.sow_partitionwall_existing_both_sides",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_partition_both_sides",
    "scopeOfWork.windwallSow.sow_windwall_partition_both_sides",
  ],
  [
    "components.partitionwall.partitionwall_extension",
    "scopeOfWork.partitionwallSow.sow_partitionwall_existing_extension",
  ],
  [
    "components.partitionwall.partitionwall_midbay_supports",
    "scopeOfWork.partitionwallSow.sow_partitionwall_mid_bay_supports",
  ],
  [
    "components.partitionwall.partitionwall_longl_b2b",
    "scopeOfWork.partitionwallSow.sow_partitionwall_back_to_back_longl",
  ],

  [
    "components.fandeck.fandeck_joist_orientation",
    "scopeOfWork.fandeckSow.sow_fandeck_joist_orientation",
    "scopeOfWork.partitionwallSow.sow_partitionwall_fandeck_joist_orientation",
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_joist_orientation",
    "scopeOfWork.mngSupportSow.sow_mng_joist_orientation",
    "scopeOfWork.firewallSow.sow_firewall_fandeck_joist_orientation",
  ],
  [
    "components.fill.fill_orientation_cf",
    "scopeOfWork.fillSow.sow_fill_supports_orientation",
    "scopeOfWork.firewallSow.sow_firewall_fill_support_orientation",
    "scopeOfWork.partitionwallSow.sow_partitionwall_fill_support_orientation",
    "scopeOfWork.windwallSow.sow_windwall_fill_support_orientation",
  ],
  [
    "components.fill.fill_midbay_supports_per_bay_cf",
    "scopeOfWork.fillSow.sow_fill_mid_bay_qty",
  ],
  [
    "components.fill.fill_midbay_supports_per_bay_other_cf",
    "scopeOfWork.fillSow.sow_fill_mid_bay_qty_other",
  ],
  [
    "components.fill.fill_midbay_support_matl_cf",
    "scopeOfWork.fillSow.sow_fill_mid_bay_material",
  ],
  [
    "components.fill.fill_midbay_support_wood_type_cf",
    "scopeOfWork.fillSow.sow_fill_midbay_support_wood_type_cf",
  ],
  [
    "components.fill.fill_midbay_support_wood_type_other_cf",
    "scopeOfWork.fillSow.sow_fill_sub_supports_wood_size_other",
  ],
  [
    "components.fill.fill_midbay_support_fiberglass_type_cf",
    "scopeOfWork.fillSow.sow_fill_midbay_support_fiberglass_type_cf",
  ],
  [
    "components.fill.fill_midbay_support_fiberglass_type_other_cf",
    "scopeOfWork.fillSow.sow_fill_midbay_support_fiberglass_type_other_cf",
  ],
  [
    "components.fandeck.fandeck_joist_material_frp",
    "scopeOfWork.mngSupportSow.sow_mng_joist_frp_type",
    "scopeOfWork.fanstackSow.sow_fanstack_joist_frp_type",
    "scopeOfWork.fandeckSow.sow_fandeck_joist_material_frp",
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_fandeck_joist_material_frp",
    "scopeOfWork.partitionwallSow.sow_partitionwall_fandeck_joist_material_frp",
    "scopeOfWork.firewallSow.sow_firewall_fandeck_joist_material_frp",
  ],
  [
    "components.fandeck.fandeck_joist_material_frp_other",
    "scopeOfWork.mngSupportSow.sow_mng_joist_frp_type_other",
    "scopeOfWork.fanstackSow.sow_fanstack_joist_frp_other",
    "scopeOfWork.fandeckSow.sow_fandeck_joist_material_frp_other",
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_fandeck_joist_material_frp_other",
    "scopeOfWork.partitionwallSow.sow_partitionwall_fandeck_joist_material_frp_other",
    "scopeOfWork.firewallSow.sow_firewall_fandeck_joist_material_frp_other",
  ],
  [
    "components.fill.fill_model_cf",
    "scopeOfWork.partitionwallSow.sow_partitionwall_splash_model",
  ],
  [
    "components.fill.fill_model_splash_cf",
    "components.fill.fill_model_splash_xf",
    "components.fill.fill_model_cf",
    "components.fill.fill_model_cf",
    "scopeOfWork.fillSow.sow_fill_model",
    "scopeOfWork.firewallSow.sow_firewall_splash_model",
    "scopeOfWork.partitionwallSow.sow_partitionwall_splash_model",
  ],
  [
    "components.fill.fill_depth_in_air_inlet_cf",
    "scopeOfWork.firewallSow.sow_firewall_splash_depth_in_inlet",
    "scopeOfWork.partitionwallSow.sow_partitionwall_splash_depth_inlet",
  ],
  [
    "components.fill.fill_depth_splash_cf",
    "components.fill.fill_depth_splash_xf",
    "components.fill.fill_depth_cf",
    "components.fill.fill_depth_cf",
    "scopeOfWork.firewallSow.sow_firewall_fill_depth",
    "scopeOfWork.fillSow.sow_fill_depth",
    "scopeOfWork.partitionwallSow.sow_partitionwall_fill_depth",
  ],
  [
    "components.fill.fill_depth_splash_consistent_cf",
    "components.fill.fill_depth_splash_consistent_xf",
    "components.fill.fill_depth_film_fill_consistent_cf",
    "components.fill.fill_depth_modular_splash_consistent_cf",
  ],
  [
    "components.fill.fill_depth_splash_explanation_cf",
    "components.fill.fill_depth_splash_explanation_xf",
    "components.fill.fill_depth_film_fill_explanation_cf",
    "components.fill.fill_depth_modular_splash_explanation_cf",
  ],
  [
    "components.fill.fill_depth_above_air_inlet_cf",
    "scopeOfWork.partitionwallSow.sow_partitionwall_splash_depth_above",
    "scopeOfWork.firewallSow.sow_firewall_splash_depth_above",
    "scopeOfWork.fillSow.sow_fill_depth_above",
  ],
  [],
  [
    "components.fill.fill_support_splash_describe_cf",
    "scopeOfWork.firewallSow.sow_firewall_splash_support_describe",
    "scopeOfWork.fillSow.sow_fill_support_description",
  ],
  [
    "components.fill.fill_spacing_above_air_inlet_splash_cf",
    "scopeOfWork.firewallSow.sow_firewall_splash_spacing_above",
    "scopeOfWork.partitionwallSow.sow_partitionwall_splash_spacing_above",
  ],
  [
    "components.fill.fill_spacing_in_air_inlet_cf",
    "scopeOfWork.firewallSow.sow_firewall_splash_spacing_in_inlet",
    "scopeOfWork.partitionwallSow.sow_partitionwall_splash_spacing_inlet",
  ],
  [
    "components.fill.fill_support_material_cf",
    "scopeOfWork.fillSow.sow_fill_support_material_cf",
    "scopeOfWork.windwallSow.sow_windwall_fill_support_material",
    "scopeOfWork.firewallSow.sow_firewall_fill_support_material",
    "scopeOfWork.partitionwallSow.sow_partitionwall_fill_support_material",
  ],
  [
    "components.fill.fill_support_wood_type_cf",
    "scopeOfWork.firewallSow.sow_firewall_fill_support_wood_size",
    "scopeOfWork.fillSow.sow_fill_support_wood_type_cf",
    "scopeOfWork.partitionwallSow.sow_partitionwall_fill_support_wood_type_cf",
    "scopeOfWork.windwallSow.sow_windwall_fill_support_wood_type_cf",
  ],
  [
    "components.fill.fill_support_wood_type_other_cf",
    "scopeOfWork.firewallSow.sow_firewall_fill_support_wood_size_other",
    "scopeOfWork.fillSow.sow_fill_support_wood_type_other_cf",
    "scopeOfWork.partitionwallSow.sow_partitionwall_fill_support_wood_type_other_cf",
    "scopeOfWork.windwallSow.sow_windwall_fill_support_wood_type_other_cf",
  ],
  [
    "components.fill.fill_support_fiberglass_type_cf",
    "scopeOfWork.firewallSow.sow_firewall_fill_support_frp_size",
    "scopeOfWork.fillSow.sow_fill_support_fiberglass_type_cf",
    "scopeOfWork.partitionwallSow.sow_partitionwall_fill_support_fiberglass_type_cf",
    "scopeOfWork.windwallSow.sow_windwall_fill_support_fiberglass_type_cf",
  ],
  [
    "components.fill.fill_support_fiberglass_type_other_cf",
    "scopeOfWork.firewallSow.sow_firewall_fill_support_frp_size_other",
    "scopeOfWork.fillSow.sow_fill_support_fiberglass_type_other_cf",
    "scopeOfWork.partitionwallSow.sow_partitionwall_fill_support_fiberglass_type_other_cf",
    "scopeOfWork.windwallSow.sow_windwall_fill_support_fiberglass_type_other_cf",
  ],
  [
    "components.fill.fill_connection_hardware_wood_cf",
    "scopeOfWork.fillSow.sow_fill_connection_hardware_wood_cf",
  ],
  [
    "components.fill.fill_connection_hardware_wood_other_cf",
    "scopeOfWork.fillSow.sow_fill__connection_hardware_wood_other_cf",
  ],
  [
    "components.fill.fill_connection_hardware_frp_cf",
    "scopeOfWork.fillSow.sow_fill_connection_hardware_frp_cf",
  ],
  [
    "components.fill.fill_connection_hardware_frp_other_cf",
    "scopeOfWork.fillSow.sow_fill__connection_hardware_frp_other_cf",
  ],
  [
    "components.fill.fill_connections_includes_bushing_cf",
    "scopeOfWork.fillSow.sow_fill_connections_includes_bushing_cf",
  ],
  [
    "components.fill.fill_connections_includes_sleeves_cf",
    "scopeOfWork.fillSow.sow_fill_connections_includes_sleeves_cf",
  ],
  [
    "components.fill.fill_sub_support_matl_cf",
    "scopeOfWork.fillSow.sow_fill_sub_supports_material",
    "scopeOfWork.firewallSow.sow_firewall_fill_subsupport_material",
    "scopeOfWork.partitionwallSow.sow_partitionwall_fill_sub_support_matl_cf",
    "scopeOfWork.windwallSow.sow_windwall_fill_subsupport_matl_cf",
  ],
  [
    "components.fill.fill_sub_support_wood_type_cf",
    "scopeOfWork.fillSow.sow_fill_sub_support_wood_type_cf",
    "scopeOfWork.firewallSow.sow_firewall_fill_subsupport_wood_size",
    "scopeOfWork.partitionwallSow.sow_partitionwall_fill_sub_support_wood_type_cf",
    "scopeOfWork.windwallSow.sow_windwall_fill_sub_support_wood_type_cf",
  ],
  [
    "components.fill.fill_sub_support_wood_type_other_cf",
    "scopeOfWork.firewallSow.sow_firewall_fill_subsupport_wood_size_other",
    "scopeOfWork.fillSow.sow_fill_sub_support_wood_type_other_cf",
    "scopeOfWork.partitionwallSow.sow_partitionwall_fill_sub_support_wood_type_other_cf",
    "scopeOfWork.windwallSow.sow_windwall_fill_sub_support_wood_type_other_cf",
  ],
  [
    "components.fill.fill_sub_support_connection_hardware_wood_cf",
    "scopeOfWork.fillSow.sow_fill_sub_support_connection_hardware_wood_cf",
  ],
  [
    "components.fill.fill_sub_support_connection_hardware_wood_other_cf",
    "scopeOfWork.fillSow.sow_fill_fill_sub_support_connection_hardware_wood_other_cf",
  ],
  [
    "components.fill.fill_sub_support_orientation_cf",
    "scopeOfWork.fillSow.sow_fill_sub_supports_orientation",
    "scopeOfWork.partitionwallSow.sow_partitionwall_fill_support_orientation",
  ],
  [
    "components.fill.fill_sub_support_fiberglass_type_cf",
    "scopeOfWork.firewallSow.sow_firewall_fill_subsupport_frp_size",
    "scopeOfWork.fillSow.sow_fill_sub_support_fiberglass_type_cf",
    "scopeOfWork.partitionwallSow.sow_partitionwall_fill_sub_support_fiberglass_type_cf",
    "scopeOfWork.windwallSow.sow_windwall_fill_sub_support_fiberglass_type_cf",
  ],
  [
    "components.fill.fill_sub_support_fiberglass_type_other_cf",
    "scopeOfWork.firewallSow.sow_firewall_fill_subsupport_frp_size_other",
    "scopeOfWork.fillSow.sow_fill_sub_support_fiberglass_type_other_cf",
    "scopeOfWork.partitionwallSow.sow_partitionwall_fill_sub_support_fiberglass_type_other_cf",
    "scopeOfWork.windwallSow.sow_windwall_fill_sub_support_fiberglass_type_other_cf",
  ],
  [
    "components.fill.fill_sub_support_connection_hardware_frp_cf",
    "scopeOfWork.fillSow.sow_fill_sub_support_connection_hardware_frp_cf",
  ],
  [
    "components.fill.fill_sub_support_connection_hardware_frp_other_cf",
    "scopeOfWork.fillSow.sow_fill_sub_support_connection_hardware_frp_other_cf",
  ],
  [
    "components.fill.fill_sub_support_connections_includes_bushing_cf",
    "scopeOfWork.fillSow.sow_fill_sub_support_connections_includes_bushing_cf",
  ],
  [
    "components.fill.fill_sub_support_connections_includes_sleeves_cf",
    "scopeOfWork.fillSow.sow_fill_sub_support_connections_includes_sleeves_cf",
  ],
  [
    "components.fill.fill_support_splash_describe_cf",
    "scopeOfWork.partitionwallSow.sow_partitionwall_splash_support_describe",
  ],
  [
    "components.partitionwall.partitionwall_quantity",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_partition_quantity",
    "scopeOfWork.windwallSow.sow_windwall_partition_wall_quantity",
  ],
  [
    "components.firewall.firewall_material",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_firewall_material",
    "scopeOfWork.firewallSow.sow_firewall_existing_material",
    "scopeOfWork.structureSow.sow_structure_fire_material",
  ],
  [
    "components.firewall.firewall_material_other",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_firewall_material_other",
    "scopeOfWork.structureSow.sow_structure_fire_material_other",
    "scopeOfWork.firewallSow.sow_firewall_material_other",
  ],
  [
    "components.firewall.firewall_quantity",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_firewall_quantity",
  ],
  [
    "components.firewall.firewall_midbay_supports",
    "scopeOfWork.firewallSow.sow_firewall_mid_bay_supports",
  ],
  [
    "components.driftEliminators.de_type_cf",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_existing_type",
    "scopeOfWork.driftEliminatorsCFSow.sow_de_cf_cf_existing_type",
  ],
  [
    "components.driftEliminators.de_support_material_cf",
    "scopeOfWork.driftEliminatorsCFSow.sow_de_cf_support_material",
  ],
  [
    "components.driftEliminators.de_sub_support_material_cf",
    "scopeOfWork.driftEliminatorsCFSow.sow_de_cf_sub_support_material",
  ],
  [
    "components.structure.structure_wood_posts",
    "scopeOfWork.distributionSystemSow.sow_distribution_posts_wood_type",
    "scopeOfWork.driftEliminatorsCFSow.sow_de_cf_wood_post_type",
    "scopeOfWork.firewallSow.sow_firewall_posts_wood_type",
    "scopeOfWork.fillSow.sow_fill_posts_wood_type",
    "scopeOfWork.structureSow.sow_structure_posts_wood_type",
    "scopeOfWork.driftEliminatorsCFSow.sow_de_cf_posts",
    "scopeOfWork.partitionwallSow.sow_partitionwall_posts_wood_type",
    "scopeOfWork.windwallSow.sow_windwall_posts_wood_type",
  ],
  [
    "components.structure.structure_wood_posts_consistent",
    "scopeOfWork.distributionSystemSow.sow_distribution_posts_wood_type_consistent",
    "scopeOfWork.driftEliminatorsCFSow.sow_de_cf_wood_post_consistent",
    "scopeOfWork.structureSow.sow_structure_posts_wood_all_4x4",
  ],
  [
    "components.structure.structure_wood_posts_description",
    "scopeOfWork.firewallSow.sow_firewall_posts_wood_type_other",
    "scopeOfWork.fillSow.sow_fill_posts_wood_type_other",
    "scopeOfWork.structureSow.structure_wood_posts_description",
    "scopeOfWork.partitionwallSow.sow_partitionwall_posts_wood_type_other",
    "scopeOfWork.windwallSow.sow_windwall_posts_wood_type_other",
  ],
  [
    "components.structure.structure_wood_ties",
    "scopeOfWork.driftEliminatorsCFSow.sow_de_xf_trans_ties_wood_type",
  ],
  [
    "components.structure.structure_fiberglass_ties",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_trans_ties_frp_type",
  ],
  ["components.mechanical.driveShaft_manufacturer"],
  ["components.mechanical.driveShaft_model"],
  [
    "components.mechanical.driveShaft_dbse",
    "scopeOfWork.driveShaftSow.sow_driveshaft_dbse",
    "scopeOfWork.mngSupportSow.sow_mng_driveshaft_dbse",
  ],
  [
    "components.mechanical.fan_numOfBlades",
    "scopeOfWork.fanSow.sow_fan_existing_blade_count",
  ],
  [
    "components.fanstack.fanstack_cut_diameter",
    "scopeOfWork.fandeckSow.sow_fandeck_fanstack_cut_diameter",
    "scopeOfWork.fanstackSow.sow_fanstack_fandeck_cut_diameter",
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_fanstack_cut_diameter",
  ],
  [
    "components.fandeck.fandeck_extensions_motors",
    "scopeOfWork.fandeckSow.sow_fandeck_motor_extension",
  ],
  [
    "components.fandeck.fandeck_extensions_motors_width",
    "scopeOfWork.fandeckSow.sow_fandeck_motor_extension_width",
  ],
  [
    "components.fandeck.fandeck_extensions_endwalls_width",
    "scopeOfWork.fandeckSow.sow_fandeck_endwall_extension_width",
  ],
  [
    "components.fandeck.fandeck_extensions_endwalls_length",
    "scopeOfWork.fandeckSow.sow_fandeck_endwall_extension_length",
  ],
  [
    "components.fandeck.fandeck_overlays_explain",
    "scopeOfWork.fandeckSow.sow_fandeck_overlays_desc",
    "scopeOfWork.fanstackSow.sow_fanstack_fandeck_overlay_explain",
  ],
  [
    "components.fandeck.fandeck_extensions_endwalls",
    "scopeOfWork.fandeckSow.sow_fandeck_endwall_extension",
  ],
  [
    "components.plenumAccessLadder.plenum_ladder_count",
    "scopeOfWork.fandeckSow.sow_fandeck_hatches_per_cell",
  ],
  [
    "components.fandeck.fandeck_overlays",
    "scopeOfWork.fandeckSow.sow_fandeck_overlays",
    "scopeOfWork.fanstackSow.sow_fanstack_fandeck_overlay",
  ],
  [
    "components.fandeck.plenum_guard_rails",
    "components.plenumAccessLadder.plenum_guard_rails",
    "scopeOfWork.fandeckSow.sow_fandeck_existing_hatch_rails",
  ],
  [
    "components.fandeck.fandeck_joist_material",
    "scopeOfWork.fandeckSow.sow_fandeck_existing_joist",
    "scopeOfWork.fanstackSow.sow_fanstack_joist_material",
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_fandeck_joist",
    "scopeOfWork.mngSupportSow.sow_mng_joist_material",
    "scopeOfWork.fandeckSow.sow_fandeck_joist_material",
    "scopeOfWork.firewallSow.sow_firewall_fandeck_joist_material",
    "scopeOfWork.partitionwallSow.sow_partitionwall_fandeck_existing_joist_material",
  ],
  [
    "components.fandeck.fandeck_numOfMidBayJoistsPerBay",
    "scopeOfWork.fandeckSow.sow_fandeck_mid_bay_joists",
  ],
  [
    "components.fandeck.fandeck_midbay_joist_material",
    "scopeOfWork.fandeckSow.sow_fandeck_mid_bay_material",
  ],
  [
    "components.fandeck.fandeck_midbay_joist_wood",
    "scopeOfWork.fandeckSow.sow_fandeck_midbay_joist_wood",
  ],
  [
    "components.fandeck.fandeck_midbay_joist_wood_other",
    "scopeOfWork.fandeckSow.sow_fandeck_midbay_joist_wood_other",
  ],
  [
    "components.fandeck.fandeck_midbay_joist_frp",
    "scopeOfWork.fandeckSow.sow_fandeck_midbay_joist_frp",
  ],
  [
    "components.fandeck.fandeck_midbay_joist_frp_other",
    "scopeOfWork.fandeckSow.sow_fandeck_midbay_joist_frp_other",
  ],
  [
    "components.fandeck.fandeck_joist_support_material",
    "scopeOfWork.fandeckSow.sow_fandeck_existing_support_material",
    "scopeOfWork.fanstackSow.sow_fanstack_joist_support_material",
  ],
  [
    "components.fandeck.fandeck_joist_support_material_wood",
    "scopeOfWork.fanstackSow.sow_fanstack_joist_support_wood_type",
  ],
  [
    "components.fandeck.fandeck_joist_support_material_wood_other",
    "scopeOfWork.fanstackSow.sow_fanstack_joist_support_wood_other",
  ],
  [
    "components.fandeck.fandeck_joist_support_material_frp",
    "scopeOfWork.fanstackSow.sow_fanstack_joist_support_frp_type",
  ],
  [
    "components.fandeck.fandeck_joist_support_material_frp_other",
    "scopeOfWork.fanstackSow.sow_fanstack_joist_support_frp_other",
  ],
  [
    "components.fandeck.fandeck_toeboard_height",
    "scopeOfWork.fandeckSow.sow_fandeck_existing_toe_board_height",
  ],
  [
    "components.fandeck.fandeck_toeboard_width",
    "scopeOfWork.fandeckSow.sow_fandeck_existing_toe_board_width",
  ],
  [
    "components.fandeck.fandeck_toeboard_material",
    "scopeOfWork.fandeckSow.sow_fandeck_existing_toeboards",
  ],
  [
    "components.fandeck.fandeck_toeboard_material_wood",
    "scopeOfWork.fandeckSow.sow_fandeck_toeboard_material_wood",
  ],
  [
    "components.fandeck.fandeck_toeboard_material_wood_other",
    "scopeOfWork.fandeckSow.sow_fandeck_toeboard_material_wood_other",
  ],
  [
    "components.fandeck.fandeck_toeboard_material_frp",
    "scopeOfWork.fandeckSow.sow_fandeck_toeboard_material_frp",
  ],
  [
    "components.fandeck.fandeck_toeboard_material_frp_other",
    "scopeOfWork.fandeckSow.sow_fandeck_toeboard_material_frp_other",
  ],
  [
    "components.fandeck.fandeck_kneerail_quantity",
    "scopeOfWork.fandeckSow.sow_fandeck_knee_rail_qty",
  ],
  ["components.fanstack.fanstack_viewport_count"],
  [
    "components.fanstack.fanstack_spider_cables",
    "scopeOfWork.fanSow.sow_fan_spider_cables",
    "scopeOfWork.fanstackSow.sow_fanstack_spider_cables",
    "scopeOfWork.gearSow.sow_gear_spider_cables",
    "scopeOfWork.mngSupportSow.sow_mng_spider_cables",
  ],
  [
    "components.fanstack.fanstack_guard",
    "scopeOfWork.fanstackSow.sow_fanstack_fan_guards",
    "scopeOfWork.gearSow.sow_gear_fan_guard",
    "scopeOfWork.fanSow.sow_fan_fan_guard",
    "scopeOfWork.mngSupportSow.sow_mng_fan_guard",
  ],
  [
    "components.fanstack.fanstack_access_door_location",
    "scopeOfWork.fanstackSow.sow_fanstack_mech_access_door_location",
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_access_hatch_location",
  ],
  [
    "components.fanstack.fanstack_access_door_full_width",
    "scopeOfWork.fanstackSow.sow_fanstack_mech_access_door_full_width",
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_full_width_segment",
  ],
  [
    "components.fanstack.fanstack_access_door_width",
    "scopeOfWork.fanstackSow.sow_fanstack_mech_access_door_width",
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_door_width",
  ],
  [
    "components.fanstack.fanstack_access_door_segment_position",
    "scopeOfWork.fanstackSow.sow_fanstack_mech_access_door_location_segment",
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_hatch_panel_location",
  ],
  [
    "components.mechanical.gear_serial",
    "scopeOfWork.gearSow.sow_gear_serial_number",
  ],
  [
    "components.mechanical.oilLines_material",
    "scopeOfWork.gearSow.sow_gear_oil_line_material",
  ],
  [
    "components.mechanical.oilLines_separateLines",
    "scopeOfWork.gearSow.sow_gear_separate_oil_line",
  ],
  [
    "components.mechanical.ventLine_material",
    "scopeOfWork.gearSow.sow_gear_vent_line_material",
  ],
  ["components.mechanical.driveShaft_serialNum"],
  [
    "components.mechanical.fan_manufacturer",
    "scopeOfWork.fanSow.sow_fan_existing_manufacturer",
  ],
  ["components.mechanical.fan_model"],
  [
    "components.fanstack.fanstack_segments_count",
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_fanstack_segments",
    "scopeOfWork.fanstackSow.sow_fanstack_mech_access_segments",
  ],
  [
    "components.mechanical.mgSupports_type",
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_mg_support_type",
    "scopeOfWork.mngSupportSow.sow_mng_type",
  ],
  [
    "components.mechanical.mgSupports_orientation",
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_mg_support_orientation",
    "scopeOfWork.mngSupportSow.sow_mng_orientation",
  ],
  [
    "components.mechanical.crossover_pipe",
    "scopeOfWork.mngSupportSow.crossover_pipe",
  ],
  [
    "components.mechanical.sow_mng_crossover_dia",
    "scopeOfWork.mngSupportSow.sow_mng_crossover_dia",
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_crossover_dia",
  ],
  [
    "components.mechanical.sow_mng_crossover_length",
    "scopeOfWork.mngSupportSow.sow_mng_crossover_length",
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_crossover_length",
  ],
  ["components.mechanical.mgSupports_outrigger_qty_motor"],
  ["components.mechanical.mgSupports_outrigger_qty_gear"],
  ["components.mechanical.mgSupports_outrigger_qty_midspan"],
  [
    "components.mechanical.mgSupports_material",
    "scopeOfWork.mngSupportSow.sow_mng_material",
  ],
  [
    "components.mechanical.vco_model",
    "scopeOfWork.mngSupportSow.sow_mng_vco_model",
  ],
  [
    "components.mechanical.fanstack_throat_height",
    "scopeOfWork.mngSupportSow.sow_mng_fanstack_throat_height",
  ],
  [
    "components.mechanical.torque_tube_diameter",
    "scopeOfWork.mngSupportSow.sow_mng_torque_tube_dia",
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_torque_tube_diameter",
  ],
  [
    "components.mechanical.torque_tube_length",
    "scopeOfWork.mngSupportSow.sow_mng_torque_tube_length",
  ],
  [
    "components.mechanical.rail_style_width",
    "scopeOfWork.mngSupportSow.sow_mng_rail_width",
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_rail_width",
  ],
  [
    "components.mechanical.rail_style_length",
    "scopeOfWork.mngSupportSow.sow_mng_rail_length",
  ],
  [
    "components.mechanical.rail_style_steel",
    "scopeOfWork.mngSupportSow.sow_mng_rail_steel",
  ],
  [
    "components.mechanical.gear_outputShaft",
    "scopeOfWork.fanSow.sow_fan_gear_output_shaft_type",
  ],
  [
    "components.mechanical.motor_nemaFrame",
    "scopeOfWork.driveShaftSow.sow_driveshaft_motor_nema_frame",
  ],
  [
    "components.windwall.windwall_material",
    "scopeOfWork.windwallSow.sow_windwall_existing_material",
  ],
  [
    "components.windwall.windwall_extension",
    "scopeOfWork.windwallSow.sow_windwall_existing_extension",
  ],
  [
    "components.windwall.vertical_midbay_supports",
    "scopeOfWork.windwallSow.sow_windwall_mid_bay_supports",
  ],
  [
    "components.structure.structure_material",
    "scopeOfWork.distributionSystemSow.sow_distribution_posts_material",
    "scopeOfWork.fillSow.sow_fill_posts_material",
    "scopeOfWork.windwallSow.sow_windwall_posts_material",
    "scopeOfWork.partitionwallSow.sow_partitionwall_posts_material",
  ],
  [
    "components.structure.structure_wood_braces",
    "scopeOfWork.structureSow.sow_structure_existing_braces",
  ],
  [
    "components.partitionwall.partitionwall_between_cells",
    "scopeOfWork.windwallSow.sow_windwall_partition_walls",
  ],
  [
    "components.firewall.firewall_exists",
    "scopeOfWork.windwallSow.sow_windwall_fire_walls",
  ],
  [
    "components.firewall.firewall_between_cells",
    "scopeOfWork.windwallSow.sow_windwall_fire_walls_between",
  ],
  [
    "components.firewall.firewall_quantity",
    "scopeOfWork.windwallSow.sow_windwall_fire_walls_quantity",
  ],
  [
    "components.windwall.frp_type",
    "scopeOfWork.windwallSow.sow_windwall_existing_frp_type",
  ],
  [
    "components.windwall.frp_type_other",
    "scopeOfWork.windwallSow.sow_windwall_existing_frp_type_other",
  ],
  [
    "components.windwall.wood_type",
    "scopeOfWork.windwallSow.sow_windwall_existing_wood_type",
  ],
  [
    "components.windwall.wood_type_other",
    "scopeOfWork.windwallSow.sow_windwall_existing_wood_type_other",
  ],
  [
    "components.windwall.material_other",
    "scopeOfWork.windwallSow.sow_windwall_existing_material_other",
  ],
  [
    "components.firewall.firewall_extension",
    "scopeOfWork.firewallSow.sow_firewall_existing_extension",
  ],
  [
    "components.firewall.firewall_longitudinal_cf",
    "scopeOfWork.firewallSow.sow_firewall_back_to_back_longl",
  ],
  [
    "components.firewall.firewall_cement_board_thickness",
    "scopeOfWork.firewallSow.sow_firewall_cement_board_thickness",
  ],
  [
    "components.firewall.firewall_frp_thickness",
    "scopeOfWork.firewallSow.sow_firewall_frp_thickness",
  ],
  [
    "components.structure.structure_trans_partition",
    "scopeOfWork.firewallSow.sow_firewall_trans_braces",
  ],
  [
    // POSTS - FIBERGLASS
    "components.structure.structure_fiberglass_posts",
    "scopeOfWork.distributionSystemSow.sow_distribution_posts_frp_type",
    "scopeOfWork.fillSow.sow_fill_posts_frp_type",
    "scopeOfWork.firewallSow.sow_firewall_posts_frp_type",
    "scopeOfWork.partitionwallSow.sow_partitionwall_posts_frp_type",
    "scopeOfWork.structureSow.sow_structure_posts_frp_type",
    "scopeOfWork.windwallSow.sow_windwall_posts_frp_type",
  ],
  [
    // STRUCTURE - FIBERGLASS - "Are they consistent?"
    "components.structure.structure_fiberglass_posts_consistent",
    "scopeOfWork.distributionSystemSow.sow_distribution_posts_frp_type_consistent",
    "scopeOfWork.structureSow.sow_structure_posts_frp_consistent",
  ],
  [
    "components.structure.structure_fiberglass_posts_other",
    "scopeOfWork.sow_firewallSow_posts_frp_type_other",
  ],
  [
    // Structure - Posts - Fiberglass - Describe"
    "components.structure.structure_fiberglass_posts_description",
    "scopeOfWork.distributionSystemSow.sow_distribution_posts_frp_type",
    "scopeOfWork.fillSow.sow_fill_posts_frp_type_other",
    "scopeOfWork.structureSow.sow_structure_posts_frp_description",
    "scopeOfWork.partitionwallSow.sow_partitionwall_posts_frp_type_other",
    "scopeOfWork.windwallSow.sow_windwall_posts_frp_type_other",
  ],
  [
    "components.distributionSystem.dist_total_gpm_cf",
    "scopeOfWork.distributionSystemSow.sow_distribution_gpm",
  ],
  [
    "components.distributionSystem.dist_header_location_inline_cf",
    "scopeOfWork.distributionSystemSow.dist_header_location_inline_cf",
  ],
  [
    "components.distributionSystem.dist_header_location_inline_other_cf",
    "scopeOfWork.distributionSystemSow.dist_header_location_inline_other_cf",
  ],
  ["components.distributionSystem.dist_header_location_b2b_cf", "scopeOfWork."],
  [
    "components.distributionSystem.dist_header_material",
    "scopeOfWork.distributionSystemSow.sow_distribution_header_material",
  ],
  [
    "components.distributionSystem.dist_header_diameter_cf",
    "scopeOfWork.distributionSystemSow.sow_distribution_header_diameter",
  ],
  [
    "components.distributionSystem.dist_header_diameter_other_cf",
    "scopeOfWork.distributionSystemSow.sow_distribution_header_diameter_other",
  ],
  [
    "components.distributionSystem.dist_riser_flange_location_cf",
    "scopeOfWork.distributionSystemSow.sow_distribution_riser_flange_location",
  ],
  [
    "components.distributionSystem.dist_riser_location_other_cf",
    "scopeOfWork.distributionSystemSow.sow_distribution_riser_flange_location_other",
  ],
  [
    "components.distributionSystem.dist_riser_flange_diameter_cf",
    "scopeOfWork.distributionSystemSow.sow_distribution_riser_flange_diameter",
  ],
  [
    "components.distributionSystem.dist_riser_flange_diameter_other_cf",
    "scopeOfWork.distributionSystemSow.sow_distribution_riser_flange_diameter_other",
  ],
  [
    "components.distributionSystem.dist_lateral_reduction_count_cf",
    "scopeOfWork.distributionSystemSow.sow_distribution_header_reductions",
  ],
  [
    "components.distributionSystem.dist_header_terminal_cf",
    "scopeOfWork.distributionSystemSow.sow_distribution_header_terminal_support",
  ],
  [
    "components.distributionSystem.dist_header_holddown_straps_cf",
    "scopeOfWork.distributionSystemSow.dist_header_holddown_straps_cf",
  ],
  [
    "components.distributionSystem.dist_lateral_diameter_cf",
    "scopeOfWork.distributionSystemSow.sow_distribution_lateral_diameter",
  ],
  [
    "components.distributionSystem.dist_lateral_diameter_other_cf",
    "scopeOfWork.distributionSystemSow.sow_distribution_lateral_diameter_other",
  ],
  [
    "components.distributionSystem.dist_lateral_per_bay_count_cf",
    "scopeOfWork.distributionSystemSow.sow_distribution_laterals_per_bay",
  ],
  [
    "components.distributionSystem.dist_lateral_per_bay_other_cf",
    "scopeOfWork.distributionSystemSow.sow_distribution_laterals_per_bay_other",
  ],
  [
    "components.distributionSystem.dist_lateral_support_material_cf",
    "scopeOfWork.distributionSystemSow.sow_distribution_lateral_support_material",
  ],
  [
    "components.distributionSystem.dist_lateral_support_wood_type_cf",
    "scopeOfWork.distributionSystemSow.sow_distribution_lateral_support_wood_type_cf",
  ],
  [
    "components.distributionSystem.dist_lateral_support_wood_other_cf",
    "scopeOfWork.distributionSystemSow.sow_distribution_lateral_support_wood_other_cf",
  ],
  [
    "components.distributionSystem.dist_lateral_support_fiberglass_type_cf",
    "scopeOfWork.distributionSystemSow.sow_distribution_lateral_support_fiberglass_type_cf",
  ],
  [
    "components.distributionSystem.dist_lateral_support_fiberglass_other_cf",
    "scopeOfWork.distributionSystemSow.sow_distribution_lateral_support_fiberglass_other_cf",
  ],
  [
    "components.distributionSystem.dist_lateral_support_count_cf",
    "scopeOfWork.distributionSystemSow.sow_distribution_lateral_support_type",
  ],
  [
    "components.distributionSystem.dist_lateral_terminal_cf",
    "scopeOfWork.distributionSystemSow.sow_distribution_terminal_end",
  ],
  [
    "components.distributionSystem.dist_lateral_terminal_other_cf",
    "scopeOfWork.distributionSystemSow.sow_distribution_terminal_end_other",
  ],
  [
    "components.distributionSystem.dist_support_shims_cf",
    "scopeOfWork.distributionSystemSow.sow_distribution_lateral_support_shims",
  ],
  [
    "components.distributionSystem.dist_support_shims_details_cf",
    "scopeOfWork.distributionSystemSow.sow_distribution_lateral_support_shims_description",
  ],
  [
    "components.distributionSystem.dist_support_lateral_count_cf",
    "scopeOfWork.distributionSystemSow.sow_distribution_lateral_support_type",
  ],
  [
    "components.distributionSystem.dist_lateral_shims_cf",
    "scopeOfWork.distributionSystemSow.sow_distribution_lateral_support_shims",
  ],
  [
    "components.distributionSystem.shim_description",
    "scopeOfWork.distributionSystemSow.sow_distribution_lateral_support_shims_description",
  ],
  [
    "components.distributionSystem.dist_header_supports_cf",
    "scopeOfWork.distributionSystemSow.sow_distribution_header_supports_description",
  ],
  [
    "components.distributionSystem.dist_header_straps_cf",
    "scopeOfWork.distributionSystemSow.sow_distribution_header_straps_description",
  ],
  [
    "components.distributionSystem.dist_vent_pipe_material_cf",
    "scopeOfWork.distributionSystemSow.sow_distribution_header_material",
  ],
  [
    "components.distributionSystem.dist_vent_orientation_cf",
    "scopeOfWork.distributionSystemSow.sow_distribution_vent_orientation",
  ],
  [
    "components.driftEliminators.de_wood_type_xf",
    "scopeOfWork.driftEliminatorsXFSow.de_wood_type_xf",
  ],
  [
    "components.driftEliminators.de_wood_support_type_cf",
    "scopeOfWork.driftEliminatorsCFSow.sow_de_cf_wood_size",
  ],
  [
    "components.driftEliminators.de_structural_integration_cf",
    "scopeOfWork.driftEliminatorsCFSow.sow_de_cf_support_tie_line",
  ],
  [
    "components.driftEliminators.de_structural_integration_cf",
    "scopeOfWork.driftEliminatorsCFSow.sow_de_cf_support_tie_line",
  ],
  [
    "components.driftEliminators.de_connection_type_cf",
    "scopeOfWork.driftEliminatorsCFSow.sow_de_cf_support_connection",
  ],
  [
    "components.driftEliminators.de_support_orientation_cf",
    "scopeOfWork.driftEliminatorsCFSow.sow_de_cf_support_orientation",
  ],
  [
    "components.driftEliminators.de_midbay_joists_cf",
    "scopeOfWork.driftEliminatorsCFSow.sow_de_cf_mid_bay_supports",
  ],
  [
    "components.driftEliminators.de_midbay_joists_other_cf",
    "scopeOfWork.driftEliminatorsCFSow.sow_de_cf_mid_bay_supports_other",
  ],
  [
    "components.driftEliminators.de_midbay_joist_material_cf",
    "scopeOfWork.driftEliminatorsCFSow.sow_de_cf_mid_bay_material",
  ],
  [
    "components.driftEliminators.de_support_material_xf",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_support_material",
  ],
  [
    "components.walkways.walkway_exists",
    "scopeOfWork.fanstackSow.sow_fanstack_mech_access_walkway",
  ],
];

export const matchingFieldsGTD_Ignore = [
  [
    "generalTowerDescription.baySizeLength",
    "generalTowerDescription.baySizeWidth",
    "generalTowerDescription.baySizeWidthOther",
    "generalTowerDescription.baySizeHeight",
    "generalTowerDescription.baySizeHeightOther",
    "generalTowerDescription.fan_diameter",
    "generalTowerDescription.louver_exists",
    "components.louvers.louver_exists_cf",
    "components.louvers.louver_exists_xf",
    "components.louvers.louver_exists",
    "generalTowerDescription.louver_row_count",
    "components.louvers.louver_row_count_cf",
    "components.louvers.louver_row_count_xf",
    "components.louvers.louver_row_count",
    "generalTowerDescription.louver_blade_width",
    "components.louvers.louver_blade_width_cf",
    "components.louvers.louver_blade_width_xf",
    "components.louvers.louver_blade_width",
    "components.louvers.louver_blade_width_other_cf",
    "components.louvers.louver_blade_width_other_xf",
    "generalTowerDescription.stairway_count",
    "components.stairway.stairway_count",
    "generalTowerDescription.stairway_count",
    "components.stairway.stairway_count_other",

    "generalTowerDescription.fill_type",
    "generalTowerDescription.fanstack_height",
  ],
];

export const matchingFieldsGTD = [
  [
    "components.fakefordatamatch.baySizeLength",
    // "generalTowerDescription.baySizeLength",
    "scopeOfWork.driftEliminatorsCFSow.sow_de_cf_bay_length",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_bay_length",
    "scopeOfWork.fandeckSow.sow_fandeck_bay_length",
    "scopeOfWork.distributionSystemSow.sow_distribution_bay_size_length",
    "scopeOfWork.fillSow.sow_fill_bay_size_length",
    "scopeOfWork.structureSow.sow_structure_bay_size_length",
    "scopeOfWork.partitionwallSow.sow_partitionwall_bay_size_length",
    "scopeOfWork.mngSupportSow.sow_mng_bay_size",
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_bay_size_length",
    "scopeOfWork.windwallSow.sow_windwall_bay_size_length",
    "scopeOfWork.laddersSow.sow_ladder_longl_bay_length",
    "scopeOfWork.firewallSow.sow_firewall_bay_size_length",
    "scopeOfWork.fanstackSow.sow_fanstack_bay_length",
    "scopeOfWork.stairwaySow.sow_stairway_longl_bay_length",
  ],
  [
    "components.fakefordatamatch.baySizeLengthOther",
    // "generalTowerDescription.baySizeLength",
    "scopeOfWork.driftEliminatorsCFSow.sow_de_cf_bay_length_other",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_bay_length_other",
    "scopeOfWork.fandeckSow.sow_fandeck_bay_length_other",
    "scopeOfWork.distributionSystemSow.sow_distribution_bay_size_length_other",
    "scopeOfWork.fillSow.sow_fill_bay_size_length_other",
    "scopeOfWork.structureSow.sow_structure_bay_size_length_other",
    "scopeOfWork.partitionwallSow.sow_partitionwall_bay_size_length_other",
    "scopeOfWork.mngSupportSow.sow_mng_bay_size_other",
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_bay_size_length_other",
    "scopeOfWork.windwallSow.sow_windwall_bay_size_length_other",
    "scopeOfWork.laddersSow.sow_ladder_longl_bay_length_other",
    "scopeOfWork.firewallSow.sow_firewall_bay_size_length_other",
    "scopeOfWork.fanstackSow.sow_fanstack_bay_length_other",
    "scopeOfWork.stairwaySow.sow_stairway_longl_bay_length_other",
  ],
  [
    "components.fakefordatamatch.baySizeWidth",
    // "generalTowerDescription.baySizeWidth",
    "scopeOfWork.fandeckSow.sow_fandeck_bay_width",
    "scopeOfWork.distributionSystemSow.sow_distribution_bay_size_width",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_bay_width",
    "scopeOfWork.driftEliminatorsCFSow.sow_de_bay_width_cf",
    "scopeOfWork.fillSow.sow_fill_bay_size_width",
    "scopeOfWork.firewallSow.sow_firewall_bay_size_width",
    "scopeOfWork.structureSow.sow_structure_bay_size_width",
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_bay_size_width",
    "scopeOfWork.windwallSow.sow_windwall_bay_size_width",
    "scopeOfWork.laddersSow.sow_ladder_trans_bay_width",
    "scopeOfWork.partitionwallSow.sow_partitionwall_bay_size_width",
    "scopeOfWork.stairwaySow.sow_stairway_trans_bay_width",
  ],
  [
    "components.fakefordatamatch.baySizeWidthOther",
    // "generalTowerDescription.baySizeWidthOther",
    "scopeOfWork.fandeckSow.sow_fandeck_bay_width_other",
    "scopeOfWork.distributionSystemSow.sow_distribution_bay_size_width_other",
    "scopeOfWork.fillSow.sow_fill_bay_size_width_other",
    "scopeOfWork.firewallSow.sow_firewall_bay_size_width_other",
    "scopeOfWork.structureSow.sow_structure_bay_size_width_other",
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_bay_size_width_other",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_bay_width_other",
    "scopeOfWork.driftEliminatorsCFSow.sow_de_cf_bay_width_other",
    "scopeOfWork.windwallSow.sow_windwall_bay_size_width_other",
    "scopeOfWork.laddersSow.sow_ladder_trans_bay_width_other",
    "scopeOfWork.partitionwallSow.sow_partitionwall_bay_size_width_other",
    "scopeOfWork.stairwaySow.sow_stairway_trans_bay_width_other",
  ],
  [
    "components.fakefordatamatch.baySizeHeight",
    //"generalTowerDescription.baySizeHeight",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_bay_height",
    "scopeOfWork.structureSow.sow_structure_bay_size_height",
  ],
  [
    "components.fakefordatamatch.baySizeHeightOther",
    //"generalTowerDescription.baySizeHeightOther",
    "scopeOfWork.driftEliminatorsCFSow.sow_de_cf_bay_height_other",
    "scopeOfWork.driftEliminatorsXFSow.sow_de_xf_bay_height_other",
    "scopeOfWork.structureSow.sow_structure_bay_size_height_other",
  ],
  [
    //"generalTowerDescription.fan_diameter",
    "components.mechanical.fan_diameter",
    "components.fanstack.fanstack_diameter",
    "scopeOfWork.driveShaftSow.sow_driveshaft_fan_diameter",
    "scopeOfWork.fanSow.sow_fan_diameter",
    "scopeOfWork.fandeckSow.sow_fandeck_fan_diameter",
    "scopeOfWork.gearSow.sow_gear_fan_diameter",
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_fan_diameter",
    "scopeOfWork.mngSupportSow.sow_mng_fan_diameter",
    "scopeOfWork.fanstackSow.sow_fanstack_diameter",
  ],
  [
    // "generalTowerDescription.fan_diameter",
    "components.mechanical.fan_diameter_other",
    "components.fanstack.fanstack_diameter_other",
    "scopeOfWork.driveShaftSow.sow_driveshaft_fan_diameter_other",
    "scopeOfWork.fanSow.sow_fan_diameter_other",
    "scopeOfWork.fandeckSow.sow_fandeck_fan_diameter_other",
    "scopeOfWork.gearSow.sow_gear_fan_diameter_other",
    "scopeOfWork.mechanicalAccessSow.sow_mechaccess_fan_diameter_other",
    "scopeOfWork.mngSupportSow.sow_mng_fan_diameter_other",
    "scopeOfWork.fanstackSow.sow_fanstack_diameter_other",
  ],
  [
    //"generalTowerDescription.fill_type",
    "components.fill.fill_type_cf",
    "components.fill.fill_type_xf",
    "components.fill.fill_type",
    "scopeOfWork.fillSow.sow_fill_existing_type",
    "scopeOfWork.firewallSow.sow_firewall_existing_fill_type",
    "scopeOfWork.partitionwallSow.sow_partitionwall_existing_fill_type",
  ],
  [
    //"generalTowerDescription.fill_type",
    "components.fill.fill_type_other_cf",
    "components.fill.fill_type_other_xf",
    "components.fill.fill_type_other",
    "scopeOfWork.partitionwallSow.sow_partitionwall_fill_type_other",
    "scopeOfWork.fillSow.sow_fill_support_description",
    "scopeOfWork.fillSow.sow_fill_type_other",
    "scopeOfWork.firewallSow.sow_firewall_fill_type_other",
  ],
  [
    // "generalTowerDescription.fanstack_height",
    "components.mechanical.fanstack_height",
    "components.fanstack.fanstack_height",
    "scopeOfWork.mngSupportSow.sow_mng_fanstack_height",
    "scopeOfWork.fanSow.sow_fan_spider_cables_height",
    "scopeOfWork.fandeckSow.sow_fandeck_fanstack_height",
    "scopeOfWork.fanstackSow.sow_fanstack_height_existing",
    "scopeOfWork.gearSow.sow_gear_fanstack_height",
  ],
  [
    // "generalTowerDescription.fanstack_height",
    "components.fanstack.fanstack_height_other",
    "scopeOfWork.fanSow.sow_fan_spider_cables_height_other",
    "scopeOfWork.fandeckSow.sow_fandeck_fanstack_height_other",
    "scopeOfWork.fanstackSow.sow_fanstack_height_existing_other",
    "scopeOfWork.gearSow.sow_gear_fanstack_height_other",
    "scopeOfWork.mngSupportSow.sow_mng_fanstack_height_other",
  ],
];

export const updateMatchingFields = (
  data,
  fieldPath,
  value,
  matchingFieldsArray
) => {
  matchingFieldsArray.forEach((fieldGroup) => {
    if (fieldGroup.includes(fieldPath)) {
      fieldGroup.forEach((path) => {
        const pathParts = path.split(".");
        let current = data;

        for (let i = 0; i < pathParts.length - 1; i++) {
          if (!current[pathParts[i]]) {
            current[pathParts[i]] = {};
          }
          current = current[pathParts[i]];
        }

        current[pathParts[pathParts.length - 1]] = value;
      });
    }
  });
  return data;
};
